import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline'
import { accountTypeWithBorrower, InputType } from 'config'
import { IVisibleLogic } from 'config/loan.input.visibility.type'
import { RenderInput } from 'utils/RenderInput'

interface IVisibleLogicByAccountTypes {
  accountTypes: string[]
  visibleLogic: IVisibleLogic[][]
}

type VisibleLogicByAccountTypesValue = IVisibleLogicByAccountTypes[]

export const VisibleLogicByAccountTypes = ({
  value,
  onChange,
  input,
}: {
  value?: VisibleLogicByAccountTypesValue | IVisibleLogicByAccountTypes
  onChange: Function
  input: InputType
}) => {
  const items: VisibleLogicByAccountTypesValue = Array.isArray(value) ? value : value ? [value] : []

  const onAdd = () => {
    onChange([...items, { accountTypes: [], visibleLogic: [] }])
  }

  const onRemove = (index: number) => {
    onChange(items.filter((_, idx) => idx !== index))
  }

  const onChangeItem = (index: number, key: keyof IVisibleLogicByAccountTypes, newValue: any) => {
    onChange(items.map((item, idx) => (idx === index ? { ...item, [key]: newValue } : item)))
  }

  return (
    <div>
      <div className="flex items-center gap-2 mb-2 text-sm font-semibold">
        <span>{input.title || 'Visible Logic By Account Types'}</span>
        <button className="btn-icon" onClick={onAdd}>
          <PlusIcon className="h-4 w-4" />
        </button>
      </div>

      {items.map((item, index) => {
        const inputs: Record<string, InputType> = {
          accountTypes: {
            inputType: 'multiselect',
            title: 'Account Types',
            options: accountTypeWithBorrower(),
            defaultSelected: false,
            value: item.accountTypes || [],
            sort: true,
          },
          visibleLogic: {
            inputType: 'visibleLogic',
            title: 'Visible Logic',
            value: item.visibleLogic || [],
            options: {
              hasCustomOrigin: true,
              hasOtherOrigin: true,
              hasNotVisible: true,
            },
          },
        }

        return (
          <div key={index} className="border border-gray-200 rounded p-2 mb-3">
            <div className="flex justify-between mb-2">
              <span className="text-sm font-semibold">Rule {index + 1}</span>
              <button className="btn-icon" onClick={() => onRemove(index)}>
                <TrashIcon className="h-4 w-4 text-rose-600" />
              </button>
            </div>

            {Object.keys(inputs).map((key) => (
              <div key={key} className="mb-2">
                <RenderInput
                  Key={`visibleLogicByAccountTypes-${index}-${key}`}
                  input={inputs[key]}
                  onChange={(_key: string, value: any) =>
                    onChangeItem(index, key as keyof IVisibleLogicByAccountTypes, value)
                  }
                />
              </div>
            ))}
          </div>
        )
      })}
    </div>
  )
}
